import { Box } from '@mui/material';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { useRequestState } from '@app/hooks';
import { ProfileInfo } from './profile-info';
import { getCandidatesDetailsByID } from '../slice';
import { Scrollbar } from '@app/components';
import { selectCandidatesDetailsByID } from '../selectors';

const CandidateDetailsPage = () => {
  const { state } = useLocation();
  const candidateId = state.id;

  const dispatch = useDispatch();
  useEffect(() => {
    if (candidateId) {
      dispatch(getCandidatesDetailsByID(candidateId));
    }
  }, [candidateId, dispatch]);

  const { data } = useRequestState({
    stateSelector: selectCandidatesDetailsByID,
    errorShown: true,
  });

  const goBack = () => {
    history.back();
  };

  return (
    <>
      <Box sx={{ mr: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Header goBack={goBack} title={Strings.page_title.details} helperText={''} />
      </Box>
      <Scrollbar>
        <ProfileInfo candidateData={data} />
      </Scrollbar>
    </>
  );
};
export { CandidateDetailsPage };
